<form class="forgot-password-form" [formGroup]="formGroup">
  <lib-form-input
    label="Email address"
    type="email"
    [parentForm]="formGroup"
    fieldName="email"
    formControlName="email"
    [required]="true"
    >
  </lib-form-input>
  <ng-content></ng-content>
  @if (error) {
    <div class="row">
      <div class="col-sm-12 center mb-1">
        <span class="error">{{ error }}</span>
      </div>
    </div>
  }
  <div class="row">
    <lib-button
      type="submit"
      text="Submit"
      variant="ghost"
      size="md"
      appearance="rounded"
      [isFullWidth]="true"
      [isDisabled]="formGroup.invalid"
    ></lib-button>
  </div>
</form>
